
import AboutHero from './components/AboutHero';
import MissionVision from './components/MissionVision';
import CoreValues from './components/CoreValues';
import WhyChooseSection from './components/WhyChooseSection';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <AboutHero />
      <MissionVision />
      <CoreValues />
      <WhyChooseSection />
      <AboutCTA />
    </div>
  );
}